import { DURATION_MEETING_MIN_TO_SHOW_FEEDBACK, ENABLE_SHOW_FEEDBACK, MEETING_STATUS } from '../base/app/constants';
import ReducerRegistry from '../base/redux/ReducerRegistry';
import { CANCEL_FEEDBACK, SUBMIT_FEEDBACK_ERROR, SUBMIT_FEEDBACK_SUCCESS, UPDATE_FEEDBACK_CONFIG, UPDATE_STATUS_MEETING } from './actionTypes';
const DEFAULT_STATE = {
    message: '',
    // The sentinel value -1 is used to denote no rating has been set and to
    // preserve pre-redux behavior.
    score: -1,
    submitted: false,
    config: {
        durationMeetingFeedback: DURATION_MEETING_MIN_TO_SHOW_FEEDBACK,
        enableMeetingFeedback: ENABLE_SHOW_FEEDBACK
    },
    isShowFeedback: MEETING_STATUS.MEETING
};
/**
 * Reduces the Redux actions of the feature features/feedback.
 */
ReducerRegistry.register('features/feedback', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case CANCEL_FEEDBACK: {
            return {
                ...state,
                message: action.message,
                score: action.score
            };
        }
        case SUBMIT_FEEDBACK_ERROR:
        case SUBMIT_FEEDBACK_SUCCESS: {
            return {
                ...state,
                message: '',
                score: -1,
                submitted: true
            };
        }
        case UPDATE_FEEDBACK_CONFIG: {
            return {
                ...state,
                config: {
                    durationMeetingFeedback: action.duration,
                    enableMeetingFeedback: action.enabled
                }
            };
        }
        case UPDATE_STATUS_MEETING: {
            return {
                ...state,
                isShowFeedback: action.status
            };
        }
    }
    return state;
});
